function scaleSVGPath(d, scaleFactor) {
    const svgPathRegex = /([^\d.])([\d.]*)+/g;
    const scaledCommandValue = ([, cmdOrSpace, value]) => {
        const scaledValue = isNaN(parseFloat(value))
            ? value
            : // Outer parseFloat removes trailing zeros from the scaled value
                parseFloat((scaleFactor * parseFloat(value)).toPrecision(6));
        return `${cmdOrSpace}${scaledValue}`;
    };
    return Array.from(d.matchAll(svgPathRegex), scaledCommandValue).join('');
}

export { scaleSVGPath };
//# sourceMappingURL=util.js.map
